import { render, staticRenderFns } from "./FormRadioGroup.vue?vue&type=template&id=e2f37ba4&"
import script from "./FormRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FormRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormRadioGroup.vue?vue&type=style&index=0&id=e2f37ba4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports